'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = require('../button/button');

var _button2 = _interopRequireDefault(_button);

require('./buttons-group.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ButtonsGroup(_ref) {
  var action = _ref.action,
      activeIndex = _ref.activeIndex,
      buttons = _ref.buttons,
      className = _ref.className,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ['action', 'activeIndex', 'buttons', 'className', 'onChange']);

  var classes = (0, _classnames2.default)('buttons-group', className);

  return _react2.default.createElement(
    'div',
    { className: classes },
    buttons.map(function (button, index) {
      var isActive = index === activeIndex;
      var type = isActive ? 'default' : 'outlined';
      var buttonClasses = (0, _classnames2.default)('buttons-group__button', isActive ? 'buttons-group__button--active' : 'buttons-group__button--inactive');

      return _react2.default.createElement(
        _button2.default,
        _extends({
          key: index,
          className: buttonClasses,
          type: type,
          action: action,
          onClick: function onClick() {
            return onChange(index);
          } }, props),
        button
      );
    })
  );
}

ButtonsGroup.propTypes = {
  action: _propTypes2.default.oneOf(['submit', 'button', 'reset']),
  className: _propTypes2.default.string,
  buttons: _propTypes2.default.array,
  activeIndex: _propTypes2.default.number,
  color: _propTypes2.default.oneOf(['primary', 'secondary', 'dark', 'light', 'neutral', 'disabled']),
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large', 'xx-large']),
  onChange: _propTypes2.default.func
};

ButtonsGroup.defaultProps = {
  action: 'button'
};

exports.default = ButtonsGroup;